import {
	DistributionSystemEntrySchema,
	type DistributionSystemEntry,
} from '#app/routes/mocra+/_form+/components/distribution-systems/schema.ts'
import {
	collectDistributionSystemErrors,
	createDistributionSystemDraft,
	sanitizeDistributionSystemDraft,
	type DistributionSystemDraft,
} from '#app/routes/mocra+/_form+/components/distribution-systems/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const distributionSystemDefinition = assertEntityDefinition<
	DistributionSystemEntry,
	DistributionSystemDraft
>({
	schema: DistributionSystemEntrySchema,
	createDraft: () => createDistributionSystemDraft(),
	sanitizeDraft: sanitizeDistributionSystemDraft,
	serialize: (draft) => {
		const sanitized = sanitizeDistributionSystemDraft(draft)
		return {
			system: sanitized.system,
			dataset: sanitized.dataset,
		}
	},
	deserialize: (entry) =>
		sanitizeDistributionSystemDraft(
			createDistributionSystemDraft({
				system: entry.system as DistributionSystemDraft['system'],
				dataset: entry.dataset,
			}),
		),
	collectErrors: collectDistributionSystemErrors,
})

export type DistributionSystemEntityDraft = DistributionSystemDraft
